import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import classNames from 'classnames';
import { Tabs } from 'carbon-components-react';
import PropTypes from 'prop-types';
import { FW_PREFIX, cssClassPrefix } from '../../../shared/constants/generalConstants.js';

var _excluded = ["type", "backgroundKind", "className"];
var BASE_CSS = "".concat(cssClassPrefix, "-tabs");
var TABS_TYPE = {
  Default: 'default',
  Container: 'container'
};
var TABS_BACKGROUNDKIND = {
  White: 'white',
  Gray: 'gray'
};
var IlTabs = /*#__PURE__*/function (_Component) {
  function IlTabs() {
    _classCallCheck(this, IlTabs);
    return _callSuper(this, IlTabs, arguments);
  }
  _inherits(IlTabs, _Component);
  return _createClass(IlTabs, [{
    key: "render",
    value:
    // per Global Style:
    // container: backgroundKind =  gray/white
    // default: backgroundKind = white
    function render() {
      var _this$props = this.props,
        type = _this$props.type,
        backgroundKind = _this$props.backgroundKind,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var newProps = _objectSpread2(_objectSpread2({}, rest), {}, {
        type: type,
        className: classNames("".concat(FW_PREFIX, "__IlTabs"), className, _defineProperty({}, "".concat(BASE_CSS, "--container"), type === TABS_TYPE.Container)),
        onKeyDown: this.keyDownHandler,
        selectionMode: 'manual'
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(FW_PREFIX, "__IlTabContainer-").concat(type === TABS_TYPE.Container ? backgroundKind : TABS_BACKGROUNDKIND.White)
      }, /*#__PURE__*/React__default.createElement(Tabs, newProps));
    }
  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(e) {
      // required keyboard navigation
      // see https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
      var tabSelector = 'button[role=tab]:not([aria-disabled=true])';
      var tabs = _toConsumableArray(e.currentTarget.querySelectorAll(tabSelector));
      var focusedTab = document.activeElement;
      var focusedTabIndex = tabs.indexOf(focusedTab);
      switch (e.key) {
        case 'ArrowLeft':
          focusedTabIndex--;
          if (focusedTabIndex === -1) {
            focusedTabIndex = tabs.length - 1;
          }
          break;
        case 'ArrowRight':
          focusedTabIndex++;
          if (focusedTabIndex === tabs.length) {
            focusedTabIndex = 0;
          }
          break;
        case 'Home':
          focusedTabIndex = 0;
          break;
        case 'End':
          focusedTabIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      // tablists have one tabbable item at any given time
      // so first make all tabs non-tabbable
      tabs.forEach(function (tab) {
        return tab.tabIndex = -1;
      });
      focusedTab = tabs[focusedTabIndex];
      if (focusedTab) {
        // then focus the tab we just navigated to
        focusedTab.focus();
        // and make it tabbable
        focusedTab.tabIndex = 0;
        // do not scroll on arrow key press
        e.preventDefault();
      }
    }
  }]);
}(Component);
_defineProperty(IlTabs, "propTypes", _objectSpread2(_objectSpread2({}, Tabs.propTypes), {}, {
  type: PropTypes.oneOf(_toConsumableArray(Object.values(TABS_TYPE))),
  backgroundKind: PropTypes.oneOf(_toConsumableArray(Object.values(TABS_BACKGROUNDKIND)))
}));
_defineProperty(IlTabs, "defaultProps", {
  type: TABS_TYPE["default"],
  backgroundKind: TABS_BACKGROUNDKIND.Gray
});

export { IlTabs, TABS_BACKGROUNDKIND, TABS_TYPE };
